import { useEffect, useState } from 'react';
import { JobPostingBookmarkType } from '@domain/vo/calendar/CalendarPcListVO';

const useBookmark = (jobPostingBookmark?: JobPostingBookmarkType) => {
  //북마크 상태 관리를 위한 Map
  const [jobPostingBookmarkMap, setJobPostingBookmarkMap] = useState<JobPostingBookmarkType>();

  useEffect(() => {
    setJobPostingBookmarkMap(jobPostingBookmark);
  }, [jobPostingBookmark]);

  const updateBookmarkStatus = (jobPostingSn: number, newBookmarkStatus: boolean) => {
    jobPostingBookmarkMap?.set(jobPostingSn, newBookmarkStatus);
  };

  return {
    jobPostingBookmarkMap,
    updateBookmarkStatus,
  };
};

export default useBookmark;
